import ConsultantDashboardIcon from "../../../assets/images/consultant_dashboard_icon.svg";
import ConsultantInstructionsIcon from "../../../assets/images/consultant_instruction_icon.svg";
import loginUser from "../../../assets/images/loginUser_icon.png";

const consultantMenu = [
  {
    key: "routekey-home",
    label: "sidebar.dashboard",
    path: "/app/dashboard",
    icon: ConsultantDashboardIcon,
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-instructions",
    label: "sidebar.instructions",
    path: "/app/instructions/list",
    icon: ConsultantInstructionsIcon,
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-leads",
    label: "sidebar.clients",
    path: "/app/client/list",
    icon: loginUser,
    vissbleOnSmallScrren: true,
  },
];

export default consultantMenu;
